export const constructUrl = (endPoint: string): string =>
  process.env.NODE_ENV === 'production'
    ? `..${endPoint}`
    : endPoint;

export const getQueryString = (params?: URLSearchParams): string =>
  params?.toString() ? `?${JSON.stringify(params)}` : '';
